export default {"src":"/_next/static/media/logo2.da4c8d45.svg","height":105,"width":105};